import './StationsSummary.css';

import { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";

import { StationsLiveStore } from "../model/StationsLiveStore";

const HeadphonesIcon = () => (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <path d="M4 14v-2a8 8 0 0 1 16 0v2" />
        <path d="M4 14a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2Z" fill="currentColor" stroke="none" />
        <path d="M20 14a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2 2 2 0 0 0 2-2v-2a2 2 0 0 0-2-2Z" fill="currentColor" stroke="none" />
    </svg>
);

/**
 * Сводный виджет слушателей по всем станциям для личного кабинета.
 * Сворачивается и убирается. Данные — из общего StationsLiveStore.
 */
export const StationsSummary = observer(() => {
    const store = StationsLiveStore.getShared();
    const [collapsed, setCollapsed] = useState(false);
    const [closed, setClosed] = useState(false);

    useEffect(() => store.start(), [store]);

    const stations = Array.from(store.live.values());
    const total = stations.reduce((sum, s) => sum + (s.online ? s.listeners : 0), 0);

    if (closed) {
        return (
            <button className="stations-summary__reopen" onClick={() => setClosed(false)}>
                <HeadphonesIcon /> Слушатели <b>{total}</b>
            </button>
        );
    }

    return (
        <section className={`stations-summary ${collapsed ? 'is-collapsed' : ''}`}>
            <header className="stations-summary__head">
                <span className="stations-summary__title">Слушатели онлайн</span>
                <span className="stations-summary__total"><b>{total}</b> всего</span>
                <button
                    className="stations-summary__btn"
                    aria-label={collapsed ? 'Развернуть' : 'Свернуть'}
                    onClick={() => setCollapsed(v => !v)}
                >
                    <span className="stations-summary__chev">▾</span>
                </button>
                <button
                    className="stations-summary__btn"
                    aria-label="Убрать"
                    onClick={() => setClosed(true)}
                >×</button>
            </header>

            <div className="stations-summary__body">
                {stations.length === 0 && (
                    <p className="stations-summary__empty">Нет данных о станциях</p>
                )}
                {stations.map(s => (
                    <div
                        key={s.shortcode}
                        className={`stations-summary__tile ${s.online ? '' : 'is-off'}`}
                        data-st={s.shortcode}
                    >
                        <div className="stations-summary__tile-top">
                            <span className="stations-summary__dot" />
                            <span className="stations-summary__name">{s.name}</span>
                        </div>
                        <div className="stations-summary__num">{s.online ? s.listeners : 0}</div>
                        <div className="stations-summary__label">
                            {s.online ? 'слушателей' : 'не в эфире'}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
});
